
    <!--
 * 电脑端-安全范围框（发布自动隐藏）
 * @LastEditTime: Thu Sep 19 2024 16:44:01 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_QIH017"  v-show="compData.isShow" :class="[`normal`,`u_c_QIH017`]" ></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"isShow":true},"en-US":{"isShow":true}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();

    // 自定义setup - 开始
    compData.isShow = false;;
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_QIH017.normal{
position:absolute;
width:100.00vh;
height:100.00vh;
z-index:-1;
border:4px solid lightgreen;
box-sizing:border-box;
top:0;
left:50%;
transform:translateX(-50%);

}
}.en-US{
.u_c_QIH017.normal{
position:absolute;
width:100.00vh;
height:100.00vh;
z-index:-1;
border:4px solid lightgreen;
box-sizing:border-box;
top:0;
left:50%;
transform:translateX(-50%);

}
}
</style>
